/**
 * Fatiado de lib/api.ts por domínio (#131, regra R3).
 */
import { get, post } from './client.js'
// ─── Bills — contas da mesa (fechar a conta, migração 0032) ──────────────────

export type BillParticipantDto = {
  id: string
  display_name: string | null
  kind: 'items' | 'fixed'
  share_cents: number
  divide_by: number
  payment_method: string | null
  mine: boolean
  created_at: number
  /** #163: líquido já pago online desta parte */
  online_paid_cents: number
}

/** #161/#163: pagamento online de uma parte da conta (features/payments). */
export type BillPaymentDto = {
  id: string
  bill_id: string
  participant_id: string | null
  slot: number | null
  amount_cents: number
  tip_cents: number
  refunded_cents: number
  currency: string
  status: 'pending' | 'processing' | 'succeeded' | 'failed' | 'canceled'
  paid_by: string | null
  created_at: number
  paid_at: number | null
}

export type BillDto = {
  id: string
  table_id: string
  table_number: number
  table_label: string | null
  mode: 'single' | 'by_people' | 'flexible'
  status: 'open' | 'awaiting_payment' | 'paid' | 'cancelled'
  people_count: number | null
  payment_methods: string[]
  shares: number[] | null
  subtotal_cents: number
  tax_cents: number
  tip_cents: number
  total_cents: number
  remaining_cents: number | null
  order_count: number
  awaiting_since: number | null
  created_at: number
  paid_at: number | null
  /** #161/#163: somatório online (líquido de reembolsos) e o que falta receber */
  online_paid_cents: number
  online_pending_cents: number
  remaining_due_cents: number
  online_payments: BillPaymentDto[]
  participants?: BillParticipantDto[]
}

export const billsApi = {
  list: (status?: 'open' | 'awaiting_payment' | 'paid' | 'cancelled') =>
    get<BillDto[]>(`/admin/bills${status ? `?status=${status}` : ''}`),
  pay: (id: string) => post<{ paid_at: number; orders_paid: number }>(`/admin/bills/${id}/pay`, {}),
  /** Único caminho para cancelar conta já enviada ao garçom (auditoria 0038). */
  cancel: (id: string) => post<null>(`/admin/bills/${id}/cancel`, {}),
  /** #163: reembolso auditado de pagamento online (gestor). */
  refund: (id: string, body: { payment_id: string; amount_cents?: number; reason?: string }) =>
    post<{
      payment_id: string
      stripe_refund_id: string
      refunded_cents: number
      remaining_refundable_cents: number
    }>(`/admin/bills/${id}/refund`, body),
}
